<template><section>
<h1>LoadingBar 页面顶部加载条</h1>
<h3>基本用法</h3>
<demo-block>
                    <div class="source" slot="source"><template>
  <div>
    <nt-button @click="showPageloading">start</nt-button>
    <nt-button type="primary" @click="finnishPageloading">finish</nt-button>
    <nt-button type="danger" @click="errorloading">error</nt-button>
  </div>
</template>


</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span>  <span class="hljs-attr">@click</span>=<span class="hljs-string">"showPageloading"</span>&gt;</span>start<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"primary"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"finnishPageloading"</span>&gt;</span>finish<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">nt-button</span> <span class="hljs-attr">type</span>=<span class="hljs-string">"danger"</span> <span class="hljs-attr">@click</span>=<span class="hljs-string">"errorloading"</span>&gt;</span>error<span class="hljs-tag">&lt;/<span class="hljs-name">nt-button</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">methods</span>: {
    showPageloading() {
      <span class="hljs-keyword">this</span>.$loadingbar.start();
    },
    finnishPageloading() {
      <span class="hljs-keyword">this</span>.$loadingbar.finish();
    },
    errorloading() {
      <span class="hljs-keyword">this</span>.$loadingbar.error();
    }
  }
};
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>Events</h3>
<table>
<thead>
<tr>
<th style="text-align:left">事件名称</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">this.$loadingbar.start();</td>
<td style="text-align:left">进度条开始</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">this.$loadingbar.finish();</td>
<td style="text-align:left">进度条完成</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">this.$loadingbar.error();</td>
<td style="text-align:left">进度条错误</td>
<td style="text-align:left">-</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
  methods: {
    showPageloading() {
      this.$loadingbar.start();
    },
    finnishPageloading() {
      this.$loadingbar.finish();
    },
    errorloading() {
      this.$loadingbar.error();
    }
  }
};
</script>